import { gql } from '@apollo/client';

export const GET_ALL_COMPLETED_QUIZZES_FOR_USER = gql`
  query GetAllCompletedQuizzesForUser {
    getAllCompletedQuizzesForUser {
      id
      userId
      userQuestions {
        questionId
        question {
          id
          prompt
          explanation
          tag
          options {
            desc
            isAnswer
          }
        }
        selectedOption {
          desc
          isAnswer
        }
      }
      isCompleted
      completedAt
      updatedAt
      createdAt
      tag
    }
  }
`;
